import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import Button from '../components/common/Button';
import FormikControl from '../components/formik/FormikControl';
// import { ENVIRONMENT } from '../ConfigVars';
// import Debug from '../components/formik/Debug';

const EmailAddressForm = ({
  initialValues, onSubmit, setIsSendingEmail,
}) => {
  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
      enableReinitialize
      onSubmit={async (values, onSubmitProps) => {
        setIsSendingEmail(true);
        await onSubmit(values, onSubmitProps);
        onSubmitProps.setSubmitting(false);
        setIsSendingEmail(false);
      }}
    >
      {(formik) => (
        <Form className="flex flex-col gap-6">
          <FormikControl
            control="input"
            type="email"
            label="Your Email"
            name="email"
          />
          <div className="mt-2 w-full">
            <Button
              variant="secondary"
              text="Send Email"
              type="submit"
              onClick={() => {}}
              disabled={formik.isSubmitting || !formik.isValid}
              loading={formik.isSubmitting}
            />
          </div>
          {/* {ENVIRONMENT === 'development' && <Debug />} */}
        </Form>
      )}
    </Formik>
  );
};

EmailAddressForm.propTypes = {
  initialValues: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
  setIsSendingEmail: PropTypes.func.isRequired,
};

export default EmailAddressForm;
